export const SET_TICKET_DATA = 'SET_TICKET_DATA';
export const SET_SINGLE_TICKET_DATA = 'SET_SINGLE_TICKET_DATA';
export const ADD_TICKET_DATA = 'ADD_TICKET_DATA';
export const DELETE_TICKET_DATA = 'DELETE_TICKET_DATA';



// WEBPACK FOOTER //
// ./src/store/modules/ticket/action-types.js